import { HubConnectionBuilder, HttpTransportType, LogLevel } from '@aspnet/signalr'
import cookie from 'vue-cookie'
import { eventBus } from './events'

const signalRConnection = process.env.VUE_APP_URL.split('/api')[0]
const connection = new HubConnectionBuilder()
  .withUrl(`${signalRConnection}/kilabhub`, {
    transport: HttpTransportType.WebSockets,
    accessTokenFactory: () => getToken()
  })
  .configureLogging(LogLevel.Information)
  .build()

connection.on('ReceiveNotification', (userId, userName) => {
  eventBus.$emit('ReceiveNotification', { userId, userName })
})

connection.on('TotalTicketCount', (val) => {
  eventBus.$emit('TotalTicketCount', val)
})

connection.on('HasNewlyAssignedTickets', (val) => {
  eventBus.$emit('HasNewlyAssignedTickets', val)
})

connection.on('HasNewOrUpdatedTickets', (val) => {
  eventBus.$emit('HasNewOrUpdatedTickets', val)
})

function getToken () {
  return cookie.get('kilab_token')
}

async function startConnection () {
  try {
    await connection.start()
    console.log('SignalR connected')
    eventBus.$emit('checkIfUnreadMailsExists')
  } catch (err) {
    console.error('SignalR connection error:', err)
    if (getToken()) setTimeout(startConnection, 5000) // Retry connection every 5 seconds
  }
}

async function stopConnection () {
  try {
    if (connection) {
      await connection.stop()
    }
  } catch (err) {
    console.error('SignalR connection error:', err)
  }
}

connection.onclose(async () => {
  console.log('SignalR disconnected, attempting to reconnect...')
  await startConnection()
})

export { connection, startConnection, stopConnection }
